export default __webpack_public_path__ + "static/media/format-type-form-header.89e29c57.svg";